import request from '@/utils/request';

/**
 * 查询供应商导入进度
 */
export async function getSupplierInformation() {
  return request.post('/vendor/getVendorImportProgress');
}
/**
 * 发送验证码
 */
export async function sendVerificationCode(data) {
  return request.post('/vendor/sendVerificationCode', data);
}
/**
 * 验证码校验
 * @param {object} data
 * @param {'email' | 'phone'} data.type
 * @param {string} data.value
 * @param {string} data.code
 */
export async function checkVerificationCode(data) {
  return request.post('/vendor/checkVerificationCode', data);
}

/**
 * 催办
 * @param {object} data
 * @param {string} data.vendorId
 */
export async function sendRemindEmail(data) {
  return request.post('/vendor/sendRemindEmail', data);
}

/**
 * 咨询
 * @param {object} data
 * @param {string} data.vendorId
 * @param {string} data.content
 */
export async function sendConsultEmail(data) {
  return request.post('/vendor/sendConsultEmail', data);
}

/**
 * 滑块验证
 * @param {object} data
 */
export async function aliYunVerification(data) {
  return request.post('/vendor/aliYunVerification', data);
}
